var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKutxisshavi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4908 0.969971H5.93521C5.72025 0.969971 5.54631 1.14391 5.54631 1.35887C5.54631 1.57383 5.72025 1.74777 5.93521 1.74777H13.552L0.99358 14.3062C0.841658 14.4581 0.841658 14.7042 0.99358 14.8561C1.06952 14.932 1.16905 14.97 1.26855 14.97C1.36804 14.97 1.46754 14.932 1.54352 14.8561L14.1019 2.29767V9.91444C14.1019 10.1294 14.2758 10.3033 14.4908 10.3033C14.7058 10.3033 14.8797 10.1294 14.8797 9.91444V1.35887C14.8797 1.14391 14.7057 0.969971 14.4908 0.969971Z",
    fill: "#050B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKutxisshavi);
export default __webpack_public_path__ + "static/media/kutxisshavi.dfee2b9dd213679d5104bf530e5e5863.svg";
export { ForwardRef as ReactComponent };